import { keyframes } from "styled-components";
import { Variants } from "framer-motion";

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut" as const,
    },
  }),
};

export const fadeLeft = {
  hidden: { opacity: 0, x: -40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export const fadeRight = {
  hidden: { opacity: 0, x: 40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

export const shakeAnimation = {
  x: [0, -4, 4, -4, 4, 0],
  transition: {
    duration: 0.3,
  },
};

export const pulseNeonBlue = keyframes`
  0% {
    box-shadow: 0 0 0px ${({ theme }) => theme.THEME.neonBlue};
  }
  50% {
    box-shadow: 0 0 12px 4px ${({ theme }) => theme.THEME.neonBlue};
  }
  100% {
    box-shadow: 0 0 0px ${({ theme }) => theme.THEME.neonBlue};
  }
`;

export const float = keyframes`
  0%, 100% {
    transform: translateY(0) translateX(0) scale(1);
    opacity: 0.8;
  }
  20% {
    transform: translateY(78px) translateX(35px) scale(1.1);
    opacity: 1;
  }
  40% {
    transform: translateY(38px) translateX(25px) scale(1.0);
    opacity: 0.8;
  }

  60% {
    transform: translateY(90px) translateX(45px) scale(1.0);
    opacity: 0.8;
  }

  85% {
    transform: translateY(40px) translateX(15px) scale(1.1);
    opacity: 1;
  }


`;
